export default (state) => {

  let newState = {
    ...state,
  }

  const cuisinesList = newState.filters.cuisines.list
  if ( cuisinesList.length > 0 ) {
    newState.filters.cuisines.list = cuisinesList.map(item => {
      return {
        ...item,
        active: false,
      }
    })
  }

  const awardsList = newState.filters.awards.list
  if ( awardsList.length > 0 ) {
    newState.filters.awards.list = awardsList.map(item => {
      return {
        ...item,
        active: false,
      }
    })
  }

  const ambiencesList = newState.filters.ambiences.list
  if ( ambiencesList.length > 0 ) {
    newState.filters.ambiences.list = ambiencesList.map(item => {
      return {
        ...item,
        active: false,
      }
    })
  }

  newState['filters']['clubOffers']['list'] =  {
    'Breakfast': {},
    'Lunch': {},
    'Afternoon Tea': {},
    'Dinner': {},
  },

  newState['filters']['clubOffers']['clubOffersOnly'] = false

  state.selections.map(selection => {

    let { field, value } = selection
    let key = ''
    if ( selection.filters ) {
      field = selection.filters[0].field
      value = selection.filters[0].value
    }

    switch(field) {
      case 'cuisines.description':
        key = 'cuisines'
        break;
      case 'awards.name':
        key = 'awards'
        break;
      case 'ambiences.description':
        key = 'ambiences'
        break;
      case 'name':
        key = 'name'
        break;
      case 'private_dining_rooms.min_capacity':
        key = 'privateDining'
        break;
      case 'membership_validities.meal.name':
        key = 'clubOffers'
        break;
      case 'limited_edition_bool':
        key = 'clubOffersOnly'
        break;
    }
    if ( key === 'cuisines' || key === 'ambiences' ) {
      const list = newState['filters'][key]['list']

      if ( list ) {
        const newList = list.map(listItem => {
          if ( listItem.name === value ) {
            return {
              ...listItem,
              active: true,
            }
          } else {
            return listItem
          }
        })
        newState['filters'][key]['list'] = newList
      }
    } if ( key === 'awards') {
      const list = newState['filters'][key]['list']

      if ( list ) {
        const newList = list.map(listItem => {
          if ( listItem.name === value ) {
            return {
              ...listItem,
              active: true,
            }
          } else {
            return listItem
          }
        })
        newState['filters'][key]['list'] = newList
      }
    }  else if ( key === 'privateDining' ) {
      newState['filters'][key]['value'] = [selection.filters[0].value, selection.filters[1].value]
    } else if ( key === 'clubOffers') {
      if ( !newState['filters']['clubOffers']['anyMeal'] ) {
        newState['filters'][key]['list'][selection.filters[0].value][selection.filters[1].value] = true
      }
    } else if ( key === 'clubOffersOnly' ) {
      newState['filters']['clubOffers']['clubOffersOnly'] = true
    }
  })

  return newState
}